import QRCode from 'qrcode'

export function generateQRCode (url) {
  try {
    return QRCode.toDataURL(url)
  } catch (err) {
    console.error(err)
    return null
  }
}

export function setPrintItem (data) {
  window.localStorage.setItem('print_item', JSON.stringify(data))
}

export function getPrintItem () {
  const printItem = window.localStorage.getItem('print_item')
  return JSON.parse(printItem)
}
